import { PropsWithChildren } from 'react'

import { CrudFormCore } from '../../CrudForm/FormCore'
import { CrudFormReadError } from '../../CrudForm/FormError/ReadError'
import { CrudFormSubmitError } from '../../CrudForm/FormError/SubmitError'

import { CrudModalFormCoreProps } from './interface'

export const CrudModalFormCore = ({
  /* -------------------------------------------------------------------------- */
  /*                               CrudForm Props                               */
  /* -------------------------------------------------------------------------- */
  name,
  schema,
  grid,
  layout,
  children
}: PropsWithChildren<CrudModalFormCoreProps>) => {
  return (
    <>
      <CrudFormReadError />
      <CrudFormCore grid={grid} layout={layout} name={name} schema={schema}>
        {children}
      </CrudFormCore>
      <CrudFormSubmitError />
    </>
  )
}
